// Batch 2: Danish (da), Dutch (nl), Finnish (fi), Estonian (et),
// Greek (el), Irish (ga).
// Merged into the main translations object via translations.js.

export const EXTRA_LANG_TRANSLATIONS_2 = {
    // ---------------- HEADER ----------------
    header_tagline: {
        da: "I en nødsituation altid først",
        nl: "Bij een noodgeval altijd eerst",
        fi: "Hätätilanteessa aina ensin",
        et: "Hädaolukorras alati esmalt",
        el: "Σε επείγον περιστατικό πάντα πρώτα",
        ga: "I gcás éigeandála, ar dtús i gcónaí",
    },
    header_emergency_number: {
        da: "Redningstjeneste {num}",
        nl: "Hulpdienst {num}",
        fi: "Hätäpalvelu {num}",
        et: "Päästeteenistus {num}",
        el: "Υπηρεσία διάσωσης {num}",
        ga: "Seirbhís éigeandála {num}",
    },
    header_scan_call: {
        da: "Scan & Call",
        nl: "Scan & Call",
        fi: "Scan & Call",
        et: "Scan & Call",
        el: "Scan & Call",
        ga: "Scan & Call",
    },
    header_qr_hint: {
        da: "Nødhjælp via QR",
        nl: "Noodhulp via QR",
        fi: "Hätäapu QR-koodilla",
        et: "Hädaabi QR-koodi kaudu",
        el: "Βοήθεια έκτακτης ανάγκης μέσω QR",
        ga: "Cabhair éigeandála trí QR",
    },
    header_clear_location: {
        da: "Fjern gemt placering",
        nl: "Opgeslagen locatie verwijderen",
        fi: "Poista tallennettu sijainti",
        et: "Eemalda salvestatud asukoht",
        el: "Διαγραφή αποθηκευμένης τοποθεσίας",
        ga: "Bain suíomh sábháilte",
    },

    // ---------------- LANGUAGE PICKER ----------------
    language_label: {
        da: "Sprog",
        nl: "Taal",
        fi: "Kieli",
        et: "Keel",
        el: "Γλώσσα",
        ga: "Teanga",
    },

    // ---------------- LANDING ----------------
    landing_emergency_title: {
        da: "Nødsituation?",
        nl: "Noodgeval?",
        fi: "Hätätilanne?",
        et: "Hädaolukord?",
        el: "Έκτακτη ανάγκη;",
        ga: "Éigeandáil?",
    },
    landing_emergency_sub: {
        da: "Start den stemmestyrede hjælp.",
        nl: "Start de gesproken begeleide hulp.",
        fi: "Aloita ääniopastettu apu.",
        et: "Alusta häälega juhitud abi.",
        el: "Ξεκινήστε τη φωνητικά καθοδηγούμενη βοήθεια.",
        ga: "Tosaigh an chabhair faoi threoir gutha.",
    },
    landing_demo_label: {
        da: "Demo",
        nl: "Demo",
        fi: "Demo",
        et: "Demo",
        el: "Επίδειξη",
        ga: "Taispeántas",
    },
    landing_demo_title: {
        da: "Jeg har ingen nødsituation, men vil se hvordan det virker.",
        nl: "Ik heb geen noodgeval maar wil zien hoe het werkt.",
        fi: "Minulla ei ole hätätilannetta, mutta haluan nähdä miten se toimii.",
        et: "Mul ei ole hädaolukorda, kuid tahan näha, kuidas see töötab.",
        el: "Δεν έχω επείγον περιστατικό αλλά θέλω να δω πώς λειτουργεί.",
        ga: "Níl éigeandáil agam ach is mian liom féachaint conas a oibríonn sé.",
    },
    landing_demo_sub: { da: "", nl: "", fi: "", et: "", el: "", ga: "" },
    landing_aed_button: {
        da: "Åbn defibrillatorkort",
        nl: "Defibrillatorkaart openen",
        fi: "Avaa defibrillaattorikartta",
        et: "Ava defibrillaatorikaart",
        el: "Άνοιγμα χάρτη απινιδωτών",
        ga: "Oscail léarscáil dífhibrileoirí",
    },
    landing_aed_button_sub: {
        da: "Find defibrillatorer i nærheden",
        nl: "Vind defibrillatoren in de buurt",
        fi: "Etsi lähellä olevat defibrillaattorit",
        et: "Leia lähedalasuvad defibrillaatorid",
        el: "Βρείτε απινιδωτές κοντά σας",
        ga: "Aimsigh dífhibrileoirí in aice láimhe",
    },
    landing_disclaimer_full: {
        da: "De angivne oplysninger tjener kun som vejledning. Brugen sker på eget ansvar og erstatter ikke din egen situationsvurdering eller professionelle anvisninger på stedet. Ingen garanti for nøjagtighed. I tvivlstilfælde ring altid til {notruf}.",
        nl: "De verstrekte informatie dient slechts ter oriëntatie. Het gebruik is voor eigen risico en vervangt geen eigen inschatting of professionele aanwijzingen ter plaatse. Geen garantie op juistheid. Bij twijfel altijd {notruf} bellen.",
        fi: "Annetut tiedot ovat vain ohjeellisia. Käyttö tapahtuu omalla vastuulla eikä korvaa omaa tilannearviota tai paikan päällä saatavia ammatillisia ohjeita. Ei takuuta oikeellisuudesta. Epävarmoissa tilanteissa soita aina {notruf}.",
        et: "Esitatud teave on üksnes suunav. Kasutamine on omal vastutusel ega asenda enda olukorra hindamist ega professionaalseid juhiseid kohapeal. Õigsus ei ole garanteeritud. Kahtluse korral helista alati numbril {notruf}.",
        el: "Οι παρεχόμενες πληροφορίες χρησιμεύουν μόνο ως καθοδήγηση. Η χρήση γίνεται με δική σας ευθύνη και δεν αντικαθιστά την προσωπική σας εκτίμηση ή τις επαγγελματικές οδηγίες επί τόπου. Καμία εγγύηση ορθότητας. Σε περίπτωση αμφιβολίας καλέστε πάντα το {notruf}.",
        ga: "Tá an t-eolas a chuirtear ar fáil mar threoir amháin. Tá an úsáid faoi do phriacal féin agus ní chuireann sé do mheasúnú féin ná treoracha gairmiúla ar an láthair as áit. Gan barántas cruinneas. I gcás amhrais glaoigh i gcónaí ar an {notruf}.",
    },
    landing_disclaimer_notruf: {
        da: "nødnummer {num}",
        nl: "noodnummer {num}",
        fi: "hätänumero {num}",
        et: "hädaabinumber {num}",
        el: "αριθμός έκτακτης ανάγκης {num}",
        ga: "uimhir éigeandála {num}",
    },
    landing_skip_to_cpr: {
        da: "Spring direkte til genoplivning",
        nl: "Ga direct naar reanimatie",
        fi: "Siirry suoraan elvytykseen",
        et: "Hüppa otse elustamisele",
        el: "Μεταβείτε απευθείας στην ανάνηψη",
        ga: "Léim díreach go hathbheochan",
    },
    landing_skip_to_cpr_sub: {
        da: "I demo-tilstand, uden triage-spørgsmål.",
        nl: "In demo-modus, zonder triage-vragen.",
        fi: "Demo-tilassa, ilman triage-kysymyksiä.",
        et: "Demo režiimis, ilma triaaži küsimusteta.",
        el: "Σε λειτουργία επίδειξης, χωρίς ερωτήσεις διαλογής.",
        ga: "I mód taispeána, gan ceisteanna triáise.",
    },
    landing_unsure_full: {
        da: "Usikker? I tvivlstilfælde foretag et {notruf}!",
        nl: "Niet zeker? Bij twijfel altijd een {notruf} doen!",
        fi: "Epävarma? Epäselvässä tilanteessa tee {notruf}!",
        et: "Pole kindel? Kahtluse korral helista {notruf}!",
        el: "Δεν είστε σίγουροι; Σε περίπτωση αμφιβολίας κάντε {notruf}!",
        ga: "Gan a bheith cinnte? I gcás amhrais déan {notruf}!",
    },
    landing_unsure_notruf: {
        da: "nødopkald",
        nl: "noodoproep",
        fi: "hätäpuhelu",
        et: "hädaabikõne",
        el: "κλήση έκτακτης ανάγκης",
        ga: "glao éigeandála",
    },
    footer_privacy: {
        da: "Privatliv",
        nl: "Privacy",
        fi: "Tietosuoja",
        et: "Privaatsus",
        el: "Απόρρητο",
        ga: "Príobháideacht",
    },
    footer_imprint: {
        da: "Aftryk",
        nl: "Colofon",
        fi: "Julkaisutiedot",
        et: "Impressum",
        el: "Ταυτότητα",
        ga: "Inphrionta",
    },

    // ---------------- SCAN & CALL BANNER ----------------
    scancall_title: {
        da: "Vi digitaliserer redningskæden.",
        nl: "We maken de reddingsketen digitaal.",
        fi: "Digitalisoimme pelastusketjun.",
        et: "Muudame päästeahela digitaalseks.",
        el: "Ψηφιοποιούμε την αλυσίδα διάσωσης.",
        ga: "Táimid ag déanamh an tslabhra tarrthála digiteach.",
    },
    scancall_sub: {
        da: "Førstehjælpsplakat på få minutter – DGUV-konform og livslangt gratis.",
        nl: "EHBO-poster in enkele minuten – DGUV-conform & levenslang gratis.",
        fi: "Ensiapujuliste muutamassa minuutissa – DGUV-yhteensopiva ja ilmainen ikuisesti.",
        et: "Esmaabiplakat mõne minutiga – DGUV-vastav ja eluaegselt tasuta.",
        el: "Αφίσα πρώτων βοηθειών σε λίγα λεπτά – σύμφωνη με το DGUV και δωρεάν εφ' όρου ζωής.",
        ga: "Póstaer garchabhrach i nóiméad – ag teacht le DGUV agus saor in aisce go deo.",
    },
    scancall_bullet_1: {
        da: "Nødopkald, førstehjælpere og placering med ét blik",
        nl: "Noodoproep, eerste hulpverleners en locatie in één oogopslag",
        fi: "Hätäpuhelu, ensiapuhenkilöt ja sijainti yhdellä silmäyksellä",
        et: "Hädaabikõne, esmaabiandjad ja asukoht ühe pilguga",
        el: "Κλήση έκτακτης ανάγκης, διασώστες και τοποθεσία με μια ματιά",
        ga: "Glao éigeandála, garchabhróirí agus suíomh ar an toirt",
    },
    scancall_bullet_2: {
        da: "Direkte på smartphonen via QR-kode",
        nl: "Rechtstreeks op de smartphone via QR-code",
        fi: "Suoraan älypuhelimeen QR-koodilla",
        et: "Otse nutitelefoni QR-koodiga",
        el: "Απευθείας στο smartphone μέσω κωδικού QR",
        ga: "Díreach ar an bhfón cliste trí chód QR",
    },
    scancall_bullet_3: {
        da: "DGUV-konform plakat – klar til brug med det samme",
        nl: "DGUV-conforme poster – meteen inzetbaar",
        fi: "DGUV-yhteensopiva juliste – heti käyttövalmis",
        et: "DGUV-vastav plakat – kohe kasutusvalmis",
        el: "Αφίσα συμβατή με DGUV – έτοιμη για χρήση αμέσως",
        ga: "Póstaer ag teacht le DGUV – réidh le húsáid láithreach",
    },
    scancall_cta: {
        da: "Start nu",
        nl: "Nu starten",
        fi: "Aloita nyt",
        et: "Alusta kohe",
        el: "Ξεκινήστε τώρα",
        ga: "Tosaigh anois",
    },

    // ---------------- EMAIL POPUP ----------------
    email_popup_title: {
        da: "Hold dig opdateret",
        nl: "Blijf op de hoogte",
        fi: "Pysy ajan tasalla",
        et: "Ole kursis",
        el: "Μείνετε ενημερωμένοι",
        ga: "Fan ar an eolas",
    },
    email_popup_body: {
        da: "Tak fordi du prøver SafetyAssist. Vi udvikler denne nødhjælp løbende. Skriv din e-mail, og få besked, så snart der er nyt.",
        nl: "Fijn dat je SafetyAssist probeert. We blijven deze noodhulp doorontwikkelen. Laat je e-mail achter en ontvang updates zodra er nieuws is.",
        fi: "Kiitos, että kokeilet SafetyAssistia. Kehitämme tätä hätäapua jatkuvasti. Jätä sähköpostiosoitteesi ja saat päivityksiä, kun on uutta.",
        et: "Tore, et proovid SafetyAssisti. Arendame seda hädaabi pidevalt edasi. Jäta oma e-post, et saada uudiseid niipea kui need ilmuvad.",
        el: "Ευχαριστούμε που δοκιμάζετε το SafetyAssist. Συνεχίζουμε να βελτιώνουμε αυτή τη βοήθεια. Αφήστε το e-mail σας για να λαμβάνετε ενημερώσεις μόλις υπάρχουν νέα.",
        ga: "Buíochas as triail a bhaint as SafetyAssist. Bímid ag forbairt na cabhrach éigeandála seo i gcónaí. Fág do ríomhphost agus gheobhaidh tú nuashonruithe nuair a thiocfaidh siad.",
    },
    email_popup_email_placeholder: {
        da: "dig@email.dk",
        nl: "jij@email.com",
        fi: "sinä@email.com",
        et: "sina@email.com",
        el: "esy@email.com",
        ga: "tusa@email.com",
    },
    email_popup_consent: {
        da: "Ved at sende accepterer jeg, at min e-mailadresse opbevares og bruges til at sende SafetyAssist-opdateringer.",
        nl: "Door te versturen ga ik akkoord met opslag van mijn e-mailadres en het ontvangen van SafetyAssist-updates.",
        fi: "Lähettämällä hyväksyn sähköpostiosoitteeni tallentamisen ja SafetyAssist-päivitysten lähettämisen.",
        et: "Saatmisega nõustun oma e-posti aadressi salvestamisega ja SafetyAssisti uudiste saatmisega.",
        el: "Με την υποβολή συμφωνώ ότι η διεύθυνση e-mail μου θα αποθηκευτεί και θα χρησιμοποιηθεί για ενημερώσεις του SafetyAssist.",
        ga: "Trí seoladh, aontaím go stórálfar mo sheoladh ríomhphoist agus go n-úsáidfear é chun nuashonruithe SafetyAssist a sheoladh.",
    },
    email_popup_submit: {
        da: "Tilmeld",
        nl: "Aanmelden",
        fi: "Tilaa",
        et: "Telli",
        el: "Εγγραφή",
        ga: "Cláraigh",
    },
    email_popup_later: {
        da: "Måske senere",
        nl: "Misschien later",
        fi: "Ehkä myöhemmin",
        et: "Võib-olla hiljem",
        el: "Ίσως αργότερα",
        ga: "B'fhéidir níos déanaí",
    },
    email_popup_thanks: {
        da: "Tak! Vi vender tilbage, så snart der er nyt.",
        nl: "Bedankt! We nemen contact op zodra er nieuws is.",
        fi: "Kiitos! Olemme yhteydessä heti kun on uutta.",
        et: "Aitäh! Võtame ühendust kohe, kui on uudiseid.",
        el: "Ευχαριστούμε! Θα επικοινωνήσουμε μόλις υπάρχουν νέα.",
        ga: "Go raibh maith agat! Beimid i dteagmháil chomh luath agus a bheidh nuacht ann.",
    },
    email_popup_error_email: {
        da: "Indtast venligst en gyldig e-mailadresse.",
        nl: "Voer een geldig e-mailadres in.",
        fi: "Anna kelvollinen sähköpostiosoite.",
        et: "Sisesta kehtiv e-posti aadress.",
        el: "Παρακαλώ εισαγάγετε έγκυρη διεύθυνση e-mail.",
        ga: "Cuir isteach seoladh ríomhphoist bailí, le do thoil.",
    },
    email_popup_error_consent: {
        da: "Accepter venligst opbevaring af din e-mailadresse.",
        nl: "Stem in met opslag van je e-mailadres.",
        fi: "Hyväksy sähköpostiosoitteesi tallentaminen.",
        et: "Palun nõustu oma e-posti aadressi salvestamisega.",
        el: "Συμφωνήστε με την αποθήκευση της διεύθυνσης e-mail σας.",
        ga: "Aontaigh le do thoil le do sheoladh ríomhphoist a stóráil.",
    },

    // ---------------- SAFETY BRIEFING ----------------
    safety_title: {
        da: "Sikkerhedsanvisninger",
        nl: "Veiligheidsaanwijzingen",
        fi: "Turvallisuusohjeet",
        et: "Ohutusjuhised",
        el: "Οδηγίες ασφαλείας",
        ga: "Treoracha sábháilteachta",
    },
    safety_line_1: {
        da: "Bevar roen!",
        nl: "Blijf rustig!",
        fi: "Pysy rauhallisena!",
        et: "Säilita rahu!",
        el: "Κρατήστε την ψυχραιμία σας!",
        ga: "Fan socair!",
    },
    safety_line_2: {
        da: "Sikr ulykkesstedet!",
        nl: "Maak de plaats van het ongeval veilig!",
        fi: "Turvaa onnettomuuspaikka!",
        et: "Kindlusta õnnetuskoht!",
        el: "Ασφαλίστε τον τόπο του ατυχήματος!",
        ga: "Cuir an láthair timpiste slán!",
    },
    safety_line_3: {
        da: "Pas på din egen sikkerhed.",
        nl: "Let op je eigen veiligheid.",
        fi: "Huolehdi omasta turvallisuudestasi.",
        et: "Hooli enda turvalisusest.",
        el: "Φροντίστε την ασφάλειά σας.",
        ga: "Tabhair aire do do shábháilteacht féin.",
    },
    safety_line_4: {
        da: "Flyt om nødvendigt personen ud af faren.",
        nl: "Verplaats de persoon zo nodig uit de gevarenzone.",
        fi: "Tarvittaessa siirrä henkilö vaaravyöhykkeeltä.",
        et: "Vajadusel vii inimene ohualast välja.",
        el: "Εάν χρειάζεται, απομακρύνετε το άτομο από τη ζώνη κινδύνου.",
        ga: "Más gá, bog an duine amach as crios an chontúirte.",
    },
    safety_hint: {
        da: "Du er ikke alene – {num} er altid tilgængelig øverst.",
        nl: "Je staat er niet alleen voor – {num} bovenaan is altijd bereikbaar.",
        fi: "Et ole yksin – {num} on aina saatavilla yläreunassa.",
        et: "Sa pole üksi – {num} on alati ülal kättesaadav.",
        el: "Δεν είστε μόνοι – το {num} είναι πάντα διαθέσιμο στην κορυφή.",
        ga: "Níl tú leat féin – tá {num} ar fáil i gcónaí ag an mbarr.",
    },
    safety_continue: {
        da: "Fortsæt",
        nl: "Verder",
        fi: "Jatka",
        et: "Jätka",
        el: "Συνέχεια",
        ga: "Ar aghaidh",
    },

    // ---------------- TRIAGE ----------------
    triage_assessment: {
        da: "Førstevurdering",
        nl: "Eerste beoordeling",
        fi: "Ensiarvio",
        et: "Esmane hindamine",
        el: "Αρχική αξιολόγηση",
        ga: "Measúnú tosaigh",
    },
    triage_demo_badge: {
        da: "Demo",
        nl: "Demo",
        fi: "Demo",
        et: "Demo",
        el: "Επίδειξη",
        ga: "Taispeántas",
    },
    triage_check_person: {
        da: "Tjek personen",
        nl: "Controleer de persoon",
        fi: "Tarkista henkilö",
        et: "Kontrolli inimest",
        el: "Ελέγξτε το άτομο",
        ga: "Seiceáil an duine",
    },
    triage_question_label: {
        da: "Spørgsmål",
        nl: "Vraag",
        fi: "Kysymys",
        et: "Küsimus",
        el: "Ερώτηση",
        ga: "Ceist",
    },
    triage_consciousness_title: {
        da: "Er personen ved bevidsthed?",
        nl: "Is de persoon bij bewustzijn?",
        fi: "Onko henkilö tajuissaan?",
        et: "Kas inimene on teadvusel?",
        el: "Έχει συνείδηση το άτομο;",
        ga: "An bhfuil an duine ina dhúiseacht?",
    },
    triage_consciousness_sub: {
        da: "Reagerende",
        nl: "Reageert",
        fi: "Reagoiva",
        et: "Reageeriv",
        el: "Αντιδρά",
        ga: "Freagrach",
    },
    triage_consciousness_tts: {
        da: "Er personen ved bevidsthed? Reagerer personen?",
        nl: "Is de persoon bij bewustzijn? Reageert hij of zij?",
        fi: "Onko henkilö tajuissaan? Reagoiko hän?",
        et: "Kas inimene on teadvusel? Kas ta reageerib?",
        el: "Έχει συνείδηση το άτομο; Αντιδρά;",
        ga: "An bhfuil an duine ina dhúiseacht? An bhfuil sé/sí freagrach?",
    },
    triage_advice_conscious_title: {
        da: "Hjælp efter situationen",
        nl: "Help op basis van de situatie",
        fi: "Auta tilanteen mukaan",
        et: "Aita vastavalt olukorrale",
        el: "Βοηθήστε ανάλογα με την κατάσταση",
        ga: "Cabhraigh de réir an staid",
    },
    triage_advice_conscious_body: {
        da: "f.eks. plej sår, berolig personen, beskyt mod nedkøling.",
        nl: "bijv. wond verzorgen, persoon kalmeren, beschermen tegen onderkoeling.",
        fi: "esim. hoida haava, rauhoittele henkilöä, suojaa kylmältä.",
        et: "nt sidu haav, rahusta inimest, kaitse alajahtumise eest.",
        el: "π.χ. φροντίστε το τραύμα, ηρεμήστε το άτομο, προστατέψτε από υποθερμία.",
        ga: "m.sh. cuir cóireáil ar an ngoin, sólás don duine, cosain ó hipiteirme.",
    },
    triage_advice_conscious_tts: {
        da: "Hjælp efter situationen, for eksempel ved at pleje såret. Tryk derefter på den store røde nødknap.",
        nl: "Help volgens de situatie, bijvoorbeeld door de wond te verzorgen. Druk daarna op de grote rode nooddrukknop.",
        fi: "Auta tilanteen mukaan, esimerkiksi hoitamalla haava. Paina sitten suurta punaista hätäpainiketta.",
        et: "Aita vastavalt olukorrale, näiteks sidudes haava. Vajuta seejärel suurele punasele hädaabinupule.",
        el: "Βοηθήστε ανάλογα με την κατάσταση, για παράδειγμα φροντίστε το τραύμα. Στη συνέχεια πατήστε το μεγάλο κόκκινο κουμπί έκτακτης ανάγκης.",
        ga: "Cabhraigh de réir an staid, mar shampla cóireáil a chur ar an ngoin. Ansin brúigh an cnaipe mór dearg éigeandála.",
    },
    triage_breathing_title: {
        da: "Trækker personen vejret?",
        nl: "Ademt de persoon?",
        fi: "Hengittääkö henkilö?",
        et: "Kas inimene hingab?",
        el: "Αναπνέει το άτομο;",
        ga: "An bhfuil an duine ag análú?",
    },
    triage_breathing_sub: {
        da: "Se, lyt, mærk",
        nl: "Kijk, luister, voel",
        fi: "Katso, kuuntele, tunne",
        et: "Vaata, kuula, tunne",
        el: "Κοιτάξτε, ακούστε, νιώστε",
        ga: "Féach, éist, mothaigh",
    },
    triage_breathing_tts: {
        da: "Trækker personen vejret? Tjek ved at se, lytte og mærke.",
        nl: "Ademt de persoon? Controleer door te kijken, luisteren en voelen.",
        fi: "Hengittääkö henkilö? Tarkista katsomalla, kuuntelemalla ja tuntemalla.",
        et: "Kas inimene hingab? Kontrolli vaadates, kuulates ja tundes.",
        el: "Αναπνέει το άτομο; Ελέγξτε κοιτάζοντας, ακούγοντας και αγγίζοντας.",
        ga: "An bhfuil an duine ag análú? Seiceáil ach féachaint, éisteacht agus mothú.",
    },
    triage_advice_breathing_title: {
        da: "Stabilt sideleje",
        nl: "Stabiele zijligging",
        fi: "Kylkiasento",
        et: "Stabiilne küliliasend",
        el: "Θέση ανάνηψης",
        ga: "Suíomh téarnaimh",
    },
    triage_advice_breathing_body: {
        da: "Læg personen i stabilt sideleje, og overvåg vejrtrækningen.",
        nl: "Leg de persoon in de stabiele zijligging en bewaak de ademhaling.",
        fi: "Aseta henkilö kylkiasentoon ja seuraa hengitystä.",
        et: "Aseta inimene stabiilsesse küliliasendisse ja jälgi hingamist.",
        el: "Τοποθετήστε το άτομο σε θέση ανάνηψης και παρακολουθήστε την αναπνοή.",
        ga: "Cuir an duine i suíomh téarnaimh agus monatóireacht a dhéanamh ar an análú.",
    },
    triage_advice_breathing_tts: {
        da: "Læg personen i stabilt sideleje. Tryk derefter på den store røde nødknap.",
        nl: "Leg de persoon in de stabiele zijligging. Druk daarna op de grote rode nooddrukknop.",
        fi: "Aseta henkilö kylkiasentoon. Paina sitten suurta punaista hätäpainiketta.",
        et: "Aseta inimene stabiilsesse küliliasendisse. Vajuta seejärel suurele punasele hädaabinupule.",
        el: "Τοποθετήστε το άτομο σε θέση ανάνηψης. Στη συνέχεια πατήστε το μεγάλο κόκκινο κουμπί έκτακτης ανάγκης.",
        ga: "Cuir an duine i suíomh téarnaimh. Ansin brúigh an cnaipe mór dearg éigeandála.",
    },
    triage_advice_no_breath_title: {
        da: "Ingen bevidsthed og ingen vejrtrækning – Ring straks",
        nl: "Geen bewustzijn en geen ademhaling – Bel direct",
        fi: "Ei tajua eikä hengitystä – Soita heti",
        et: "Pole teadvust ega hingamist – Helista kohe",
        el: "Καμία συνείδηση και καμία αναπνοή – Καλέστε αμέσως",
        ga: "Gan dúiseacht agus gan análú – Glaoigh láithreach",
    },
    triage_advice_no_breath_body: {
        da: "Ring straks {num} og begynd hjertemassage (30:2).",
        nl: "Bel onmiddellijk {num} en begin met hartmassage (30:2).",
        fi: "Soita heti {num} ja aloita paineluelvytys (30:2).",
        et: "Helista kohe {num} ja alusta südamemassaažiga (30:2).",
        el: "Καλέστε αμέσως το {num} και ξεκινήστε καρδιακές συμπιέσεις (30:2).",
        ga: "Glaoigh láithreach ar {num} agus tosaigh ar chomhbhrú cíche (30:2).",
    },
    triage_advice_no_breath_tts: {
        da: "Ingen bevidsthed og ingen vejrtrækning. Tryk straks på den store røde nødknap og begynd genoplivning.",
        nl: "Geen bewustzijn en geen ademhaling. Druk onmiddellijk op de grote rode nooddrukknop en start reanimatie.",
        fi: "Ei tajua eikä hengitystä. Paina heti suurta punaista hätäpainiketta ja aloita elvytys.",
        et: "Teadvust pole ja hingamist pole. Vajuta kohe suurele punasele hädaabinupule ja alusta elustamisega.",
        el: "Καμία συνείδηση και καμία αναπνοή. Πατήστε αμέσως το μεγάλο κόκκινο κουμπί έκτακτης ανάγκης και ξεκινήστε ανάνηψη.",
        ga: "Gan dúiseacht agus gan análú. Brúigh láithreach an cnaipe mór dearg éigeandála agus tosaigh ar athbheochan.",
    },
    triage_yes: {
        da: "Ja",
        nl: "Ja",
        fi: "Kyllä",
        et: "Jah",
        el: "Ναι",
        ga: "Tá",
    },
    triage_no: {
        da: "Nej",
        nl: "Nee",
        fi: "Ei",
        et: "Ei",
        el: "Όχι",
        ga: "Níl",
    },
    triage_advice_label: {
        da: "Anbefaling",
        nl: "Aanbeveling",
        fi: "Suositus",
        et: "Soovitus",
        el: "Σύσταση",
        ga: "Moladh",
    },
    triage_emergency_call: {
        da: "Nødopkald {num}",
        nl: "Noodoproep {num}",
        fi: "Hätäpuhelu {num}",
        et: "Hädaabikõne {num}",
        el: "Έκτακτη ανάγκη {num}",
        ga: "Éigeandáil {num}",
    },
    triage_demo_alert_urgent: {
        da: "I en rigtig nødsituation udløses opkaldet til {num} her.",
        nl: "In een echte noodsituatie wordt hier de oproep naar {num} gestart.",
        fi: "Oikeassa hätätilanteessa täällä käynnistyy soitto numeroon {num}.",
        et: "Päris hädaolukorras käivituks siin kõne numbrile {num}.",
        el: "Σε πραγματική έκτακτη ανάγκη εδώ θα γινόταν η κλήση στο {num}.",
        ga: "I bhfíor-éigeandáil dhéanfaí an glao chuig {num} anseo.",
    },
    triage_demo_alert_generic: {
        da: "I en rigtig nødsituation udløses opkaldet til {num} her.",
        nl: "In een echte noodsituatie wordt hier de oproep naar {num} gestart.",
        fi: "Oikeassa hätätilanteessa täällä käynnistyy soitto numeroon {num}.",
        et: "Päris hädaolukorras käivituks siin kõne numbrile {num}.",
        el: "Σε πραγματική έκτακτη ανάγκη εδώ θα γινόταν η κλήση στο {num}.",
        ga: "I bhfíor-éigeandáil dhéanfaí an glao chuig {num} anseo.",
    },
    breadcrumb_conscious_no: {
        da: "Ingen bevidsthed",
        nl: "Geen bewustzijn",
        fi: "Ei tajua",
        et: "Teadvust pole",
        el: "Καμία συνείδηση",
        ga: "Gan dúiseacht",
    },
    breadcrumb_conscious_yes: {
        da: "Ved bevidsthed",
        nl: "Bij bewustzijn",
        fi: "Tajuissaan",
        et: "Teadvusel",
        el: "Με συνείδηση",
        ga: "Ina dhúiseacht",
    },
    breadcrumb_breathing_no: {
        da: "Trækker ikke vejret",
        nl: "Ademt niet",
        fi: "Ei hengitä",
        et: "Ei hinga",
        el: "Δεν αναπνέει",
        ga: "Ní análaíonn",
    },
    breadcrumb_breathing_yes: {
        da: "Trækker vejret",
        nl: "Ademt",
        fi: "Hengittää",
        et: "Hingab",
        el: "Αναπνέει",
        ga: "Ag análú",
    },
    breadcrumb_called_112: {
        da: "Nødopkald foretaget",
        nl: "Noodoproep gedaan",
        fi: "Hätäpuhelu soitettu",
        et: "Hädaabikõne tehtud",
        el: "Έγινε κλήση έκτακτης ανάγκης",
        ga: "Glaodh éigeandála déanta",
    },
    demo_banner_label: {
        da: "Demo-tilstand aktiv",
        nl: "Demo-modus actief",
        fi: "Demo-tila päällä",
        et: "Demo režiim aktiivne",
        el: "Λειτουργία επίδειξης ενεργή",
        ga: "Mód taispeána gníomhach",
    },
    demo_tts_prefix: {
        da: "Demo-tilstand.",
        nl: "Demo-modus.",
        fi: "Demo-tila.",
        et: "Demo režiim.",
        el: "Λειτουργία επίδειξης.",
        ga: "Mód taispeána.",
    },

    // ---------------- CPR ----------------
    cpr_waiting_title: {
        da: "Ringer til {num}…",
        nl: "Bezig met bellen {num}…",
        fi: "Soitetaan {num}…",
        et: "Helistab {num}…",
        el: "Κλήση στο {num}…",
        ga: "Ag glaoch ar {num}…",
    },
    cpr_waiting_body: {
        da: "Tal med vagtcentralen. Når du vender tilbage til appen, starter den guidede genoplivning automatisk.",
        nl: "Praat met de meldkamer. Zodra je terugkeert in de app, start de begeleide reanimatie automatisch.",
        fi: "Puhu hätäkeskuksen kanssa. Heti kun palaat sovellukseen, ohjattu elvytys käynnistyy automaattisesti.",
        et: "Räägi häirekeskusega. Kohe kui rakendusse naased, käivitub juhitud elustamine automaatselt.",
        el: "Μιλήστε με το κέντρο επιχειρήσεων. Μόλις επιστρέψετε στην εφαρμογή, η καθοδηγούμενη ανάνηψη ξεκινά αυτόματα.",
        ga: "Labhair leis an ionad glaonna. Nuair a fhilleann tú ar an aip, tosóidh an athbheochan faoi threoir go huathoibríoch.",
    },
    cpr_start_now: {
        da: "Start nu",
        nl: "Nu starten",
        fi: "Aloita nyt",
        et: "Alusta kohe",
        el: "Ξεκινήστε τώρα",
        ga: "Tosaigh anois",
    },
    cpr_intro_title: {
        da: "Udfør genoplivning",
        nl: "Reanimatie uitvoeren",
        fi: "Suorita elvytys",
        et: "Teosta elustamine",
        el: "Εκτελέστε ανάνηψη",
        ga: "Déan athbheochan",
    },
    cpr_intro_body: {
        da: "Tryk 2× pr. sekund – 30 gange, derefter 2 indblæsninger.",
        nl: "Druk twee keer per seconde – 30 keer, daarna 2 beademingen.",
        fi: "Paina 2 kertaa sekunnissa – 30 kertaa, sitten 2 puhallusta.",
        et: "Vajuta 2 korda sekundis – 30 korda, seejärel 2 hingamist.",
        el: "Πιέστε 2× ανά δευτερόλεπτο – 30 φορές, μετά 2 εμφυσήσεις.",
        ga: "Brúigh 2× sa soicind – 30 uair, ansin 2 anáil thairbheach.",
    },
    cpr_intro_tts: {
        da: "Udfør genoplivning. Tryk to gange i sekundet i alt tredive gange, og giv derefter to indblæsninger.",
        nl: "Reanimatie uitvoeren. Druk twee keer per seconde, dertig keer, en geef daarna twee beademingen.",
        fi: "Suorita elvytys. Paina kaksi kertaa sekunnissa, kolmekymmentä kertaa, ja anna sitten kaksi puhallusta.",
        et: "Teosta elustamine. Vajuta kaks korda sekundis, kolmkümmend korda, ja seejärel anna kaks hingamist.",
        el: "Εκτελέστε ανάνηψη. Πιέστε δύο φορές το δευτερόλεπτο, τριάντα φορές, και μετά κάντε δύο εμφυσήσεις.",
        ga: "Déan athbheochan. Brúigh dhá uair sa soicind, tríocha uair, agus ansin tabhair dhá anáil.",
    },
    cpr_start_immediately: {
        da: "Fortsæt",
        nl: "Verder",
        fi: "Jatka",
        et: "Jätka",
        el: "Συνέχεια",
        ga: "Ar aghaidh",
    },
    cpr_active_title: {
        da: "Udfør HLR!",
        nl: "Voer reanimatie uit!",
        fi: "Suorita elvytys!",
        et: "Teosta elustamine!",
        el: "Εκτελέστε ΚΑΡΠΑ!",
        ga: "Déan athbheochan!",
    },
    cpr_reanimation: {
        da: "Genoplivning",
        nl: "Reanimatie",
        fi: "Elvytys",
        et: "Elustamine",
        el: "Ανάνηψη",
        ga: "Athbheochan",
    },
    cpr_counter_compressions: {
        da: "{n}/30 tryk",
        nl: "{n}/30 compressies",
        fi: "{n}/30 painallusta",
        et: "{n}/30 surumist",
        el: "{n}/30 συμπιέσεις",
        ga: "{n}/30 comhbhrú",
    },
    cpr_counter_breaths: {
        da: "{n}/2 indblæsninger",
        nl: "{n}/2 beademingen",
        fi: "{n}/2 puhallusta",
        et: "{n}/2 hingamist",
        el: "{n}/2 εμφυσήσεις",
        ga: "{n}/2 anáil",
    },
    cpr_label_compress: {
        da: "Tryk",
        nl: "Druk",
        fi: "Paina",
        et: "Vajuta",
        el: "Πιέστε",
        ga: "Brúigh",
    },
    cpr_label_breathe: {
        da: "Indblæs",
        nl: "Beadem",
        fi: "Puhalla",
        et: "Hinga",
        el: "Εμφύσηση",
        ga: "Análaigh",
    },
    cpr_bpm_line: {
        da: "110 BPM · 545 ms pr. tryk",
        nl: "110 BPM · 545 ms per compressie",
        fi: "110 BPM · 545 ms painallusta kohti",
        et: "110 BPM · 545 ms surumise kohta",
        el: "110 BPM · 545 ms ανά συμπίεση",
        ga: "110 BPM · 545 ms in aghaidh an chomhbhrú",
    },
    cpr_timer_suffix: {
        da: "30× tryk · 2× indblæsninger",
        nl: "30× compressies · 2× beademingen",
        fi: "30× painallusta · 2× puhallusta",
        et: "30× surumist · 2× hingamist",
        el: "30× συμπιέσεις · 2× εμφυσήσεις",
        ga: "30× comhbhrú · 2× anáil",
    },
    cpr_continue_hint: {
        da: "Fortsæt indtil hjælpen kommer.",
        nl: "Doorgaan tot hulp arriveert.",
        fi: "Jatka kunnes apu saapuu.",
        et: "Jätka kuni saabub abi.",
        el: "Συνεχίστε μέχρι να φτάσει βοήθεια.",
        ga: "Lean ar aghaidh go dtí go dtagann an chabhair.",
    },
    cpr_handover_tts: {
        da: "Kald efter afløsning!",
        nl: "Vraag om aflossing!",
        fi: "Pyydä vuoronvaihtoa!",
        et: "Kutsu vahetus!",
        el: "Καλέστε για αντικαταστάτη!",
        ga: "Glaoigh ar mhalairt!",
    },
    cpr_breath_tts: {
        da: "Indblæs",
        nl: "Beadem",
        fi: "Puhalla",
        et: "Hinga",
        el: "Εμφύσηση",
        ga: "Análaigh",
    },
    cpr_show_aed: {
        da: "Defibrillator i nærheden",
        nl: "Defibrillator in de buurt",
        fi: "Defibrillaattori lähellä",
        et: "Defibrillaator lähedal",
        el: "Απινιδωτής κοντά",
        ga: "Dífhibrileoir in aice láimhe",
    },

    // ---------------- AED ----------------
    aed_back: {
        da: "Tilbage",
        nl: "Terug",
        fi: "Takaisin",
        et: "Tagasi",
        el: "Πίσω",
        ga: "Siar",
    },
    aed_section_label: {
        da: "Defibrillator-søgning",
        nl: "Defibrillator zoeken",
        fi: "Defibrillaattorin haku",
        et: "Defibrillaatori otsing",
        el: "Αναζήτηση απινιδωτή",
        ga: "Cuardach dífhibrileora",
    },
    aed_confirm_title: {
        da: "Er du stadig på denne placering?",
        nl: "Bent u nog op deze locatie?",
        fi: "Oletko vielä tässä sijainnissa?",
        et: "Kas oled veel selles asukohas?",
        el: "Βρίσκεστε ακόμα σε αυτή την τοποθεσία;",
        ga: "An bhfuil tú fós ag an suíomh seo?",
    },
    aed_confirm_yes: {
        da: "Ja, fortsæt",
        nl: "Ja, doorgaan",
        fi: "Kyllä, jatka",
        et: "Jah, jätka",
        el: "Ναι, συνέχεια",
        ga: "Tá, ar aghaidh",
    },
    aed_confirm_no: {
        da: "Nej, ny placering",
        nl: "Nee, nieuwe locatie",
        fi: "Ei, uusi sijainti",
        et: "Ei, uus asukoht",
        el: "Όχι, νέα τοποθεσία",
        ga: "Níl, suíomh nua",
    },
    aed_detecting_title: {
        da: "Registrerer placering…",
        nl: "Locatie wordt bepaald…",
        fi: "Sijaintia haetaan…",
        et: "Tuvastatakse asukohta…",
        el: "Εντοπισμός τοποθεσίας…",
        ga: "Ag aimsiú an tsuímh…",
    },
    aed_detecting_sub: {
        da: "Tillad placeringsadgang i browserens dialog.",
        nl: "Sta locatietoegang toe in de browser-dialoog.",
        fi: "Salli sijaintipalvelu selaimen kyselyssä.",
        et: "Luba asukoha juurdepääs brauseri dialoogis.",
        el: "Επιτρέψτε την πρόσβαση στην τοποθεσία στο παράθυρο του browser.",
        ga: "Ceadaigh rochtain ar shuíomh i mbosca an bhrabhsálaí.",
    },
    aed_detecting_hint: {
        da: "Hvis dialogen ikke vises eller du har afvist, kan du også indtaste et postnummer.",
        nl: "Als de dialoog niet verschijnt of je hebt geweigerd, kun je ook een postcode invoeren.",
        fi: "Jos kyselyä ei näy tai kieltäydyit, voit syöttää myös postinumeron.",
        et: "Kui dialoog ei ilmu või sa keeldusid, saad ka sihtnumbri sisestada.",
        el: "Εάν το παράθυρο δεν εμφανίζεται ή το αρνηθήκατε, μπορείτε επίσης να εισάγετε ταχυδρομικό κώδικα.",
        ga: "Mura léirítear an dialóg nó má dhiúltaigh tú, is féidir leat cód poist a iontráil.",
    },
    aed_enter_plz: {
        da: "Indtast postnummer",
        nl: "Postcode invoeren",
        fi: "Syötä postinumero",
        et: "Sisesta sihtnumber",
        el: "Εισαγωγή ταχυδρομικού κώδικα",
        ga: "Cuir isteach cód poist",
    },
    aed_manual_title: {
        da: "Indtast postnummer",
        nl: "Postcode invoeren",
        fi: "Syötä postinumero",
        et: "Sisesta sihtnumber",
        el: "Εισαγωγή ταχυδρομικού κώδικα",
        ga: "Cuir isteach cód poist",
    },
    aed_manual_sub: {
        da: "Placeringsadgang er ikke aktiv – indtast dit postnummer for at finde defibrillatorer i nærheden.",
        nl: "Locatietoegang is niet actief – voer je postcode in om defibrillatoren in de buurt te vinden.",
        fi: "Sijaintipalvelu ei ole päällä – syötä postinumero löytääksesi defibrillaattoreita lähellä.",
        et: "Asukohajuurdepääs pole aktiivne – sisesta sihtnumber, et leida lähedalasuvad defibrillaatorid.",
        el: "Η πρόσβαση στην τοποθεσία δεν είναι ενεργή – εισάγετε τον ταχυδρομικό σας κώδικα για να βρείτε απινιδωτές κοντά.",
        ga: "Níl rochtain ar shuíomh gníomhach – cuir isteach do chód poist chun dífhibrileoirí in aice láimhe a aimsiú.",
    },
    aed_manual_hint: {
        da: "Tip: Du kan også tillade placering igen, hvis browseren understøtter det.",
        nl: "Tip: je kunt locatie ook opnieuw toestaan als je browser dit ondersteunt.",
        fi: "Vinkki: voit myös sallia sijainnin uudelleen, jos selain tukee sitä.",
        et: "Vihje: võid asukoha taas lubada, kui brauser seda toetab.",
        el: "Συμβουλή: μπορείτε επίσης να επιτρέψετε ξανά την τοποθεσία αν το υποστηρίζει ο browser.",
        ga: "Leid: is féidir leat suíomh a cheadú arís má thacaíonn do bhrabhsálaí leis.",
    },
    aed_find_button: {
        da: "Find defibrillatorer",
        nl: "Defibrillatoren zoeken",
        fi: "Etsi defibrillaattoreita",
        et: "Leia defibrillaatorid",
        el: "Εύρεση απινιδωτών",
        ga: "Aimsigh dífhibrileoirí",
    },
    aed_retry_gps: {
        da: "Prøv GPS igen",
        nl: "GPS opnieuw proberen",
        fi: "Yritä GPS uudelleen",
        et: "Proovi GPS uuesti",
        el: "Επανάληψη GPS",
        ga: "Triail GPS arís",
    },
    aed_toast_invalid_plz: {
        da: "Indtast venligst et gyldigt 5-cifret postnummer.",
        nl: "Voer een geldige 5-cijferige postcode in.",
        fi: "Anna kelvollinen 5-numeroinen postinumero.",
        et: "Sisesta kehtiv 5-kohaline sihtnumber.",
        el: "Παρακαλώ εισαγάγετε έγκυρο 5ψήφιο ταχυδρομικό κώδικα.",
        ga: "Cuir isteach cód poist bailí le 5 dhigit, le do thoil.",
    },
    aed_toast_plz_failed: {
        da: "Postnummeret kunne ikke findes.",
        nl: "Postcode kon niet worden gevonden.",
        fi: "Postinumeroa ei voitu tunnistaa.",
        et: "Sihtnumbrit ei õnnestunud leida.",
        el: "Ο ταχυδρομικός κώδικας δεν βρέθηκε.",
        ga: "Níorbh fhéidir an cód poist a aimsiú.",
    },
    aed_toast_no_geo: {
        da: "Browseren understøtter ikke geolokalisering.",
        nl: "Geolocatie wordt niet ondersteund door de browser.",
        fi: "Selain ei tue paikannusta.",
        et: "Brauser ei toeta geolokatsiooni.",
        el: "Ο browser δεν υποστηρίζει γεωεντοπισμό.",
        ga: "Ní thacaíonn an brabhsálaí le geo-shuíomh.",
    },
    aed_toast_geo_denied: {
        da: "Placeringsadgang afvist eller mislykkedes.",
        nl: "Locatietoestemming geweigerd of mislukt.",
        fi: "Sijaintipalvelu evätty tai epäonnistui.",
        et: "Asukohaõigus tagasi lükatud või ebaõnnestus.",
        el: "Η άδεια τοποθεσίας απορρίφθηκε ή απέτυχε.",
        ga: "Diúltaíodh nó theip ar an gcead suímh.",
    },
    aed_placeholder_plz: {
        da: "f.eks. 10115",
        nl: "bv. 10115",
        fi: "esim. 10115",
        et: "nt 10115",
        el: "π.χ. 10115",
        ga: "m.sh. 10115",
    },

    // ---------------- DEFIBRILLATOR MAP ----------------
    map_section_label: {
        da: "Defibrillatorer i nærheden",
        nl: "Defibrillatoren in de buurt",
        fi: "Defibrillaattorit lähellä",
        et: "Defibrillaatorid lähedal",
        el: "Απινιδωτές κοντά",
        ga: "Dífhibrileoirí in aice láimhe",
    },
    map_count: {
        da: "{n} defibrillatorsteder",
        nl: "{n} defibrillatorlocaties",
        fi: "{n} defibrillaattorisijaintia",
        et: "{n} defibrillaatori asukohta",
        el: "{n} τοποθεσίες απινιδωτών",
        ga: "{n} suíomh dífhibrileoirí",
    },
    map_your_location: {
        da: "Din placering",
        nl: "Jouw locatie",
        fi: "Sijaintisi",
        et: "Sinu asukoht",
        el: "Η τοποθεσία σας",
        ga: "Do shuíomh",
    },
    map_aed_label: {
        da: "Defibrillator",
        nl: "Defibrillator",
        fi: "Defibrillaattori",
        et: "Defibrillaator",
        el: "Απινιδωτής",
        ga: "Dífhibrileoir",
    },
    map_you_are_here: {
        da: "Du er her",
        nl: "Je bent hier",
        fi: "Olet täällä",
        et: "Sa oled siin",
        el: "Είστε εδώ",
        ga: "Tá tú anseo",
    },
    map_operator: {
        da: "Operatør",
        nl: "Beheerder",
        fi: "Ylläpitäjä",
        et: "Operaator",
        el: "Διαχειριστής",
        ga: "Oibreoir",
    },
    map_indoor: {
        da: "Indendørs",
        nl: "Binnen",
        fi: "Sisällä",
        et: "Sees",
        el: "Εσωτερικά",
        ga: "Faoi dhíon",
    },
    map_outdoor: {
        da: "Udendørs",
        nl: "Buiten",
        fi: "Ulkona",
        et: "Väljas",
        el: "Εξωτερικά",
        ga: "Lasmuigh",
    },
    map_opening_hours: {
        da: "Åbningstider",
        nl: "Openingstijden",
        fi: "Aukioloajat",
        et: "Lahtiolekuajad",
        el: "Ώρες λειτουργίας",
        ga: "Uaireanta oscailte",
    },

    // ---------------- COMMON ----------------
    tts_activate: {
        da: "Aktivér stemme",
        nl: "Stem aanzetten",
        fi: "Ota ääni käyttöön",
        et: "Lülita hääl sisse",
        el: "Ενεργοποίηση φωνής",
        ga: "Cuir an guth ar siúl",
    },
    tts_mute: {
        da: "Slå stemme fra",
        nl: "Stem uitschakelen",
        fi: "Mykistä ääni",
        et: "Vaigista hääl",
        el: "Σίγαση φωνής",
        ga: "Múch an guth",
    },
    reset_link: {
        da: "Gentag – tilbage til start",
        nl: "Herhalen – terug naar het begin",
        fi: "Aloita alusta – takaisin alkuun",
        et: "Korda – tagasi algusesse",
        el: "Επανάληψη – πίσω στην αρχή",
        ga: "Athnuachan – ar ais go dtí an tús",
    },
    footer_powered_by: {
        da: "Drevet af SafetyAssist",
        nl: "Mogelijk gemaakt door SafetyAssist",
        fi: "Toteuttaja: SafetyAssist",
        et: "Pakub SafetyAssist",
        el: "Με την υποστήριξη του SafetyAssist",
        ga: "Cumhachtaithe ag SafetyAssist",
    },
};
